<template>
  <form @submit.prevent="onSubmit">
    <p class="text-xs leading-snug xl:text-lg">
      {{ tr('pages.sales.checkout.form.payment.cardholder.description') }}
    </p>
    <div class="flex flex-col md:items-center md:flex-row md:justify-between">
      <TextInput
        v-model.trim="name"
        :disabled="locked"
        :label="tr('pages.sales.checkout.form.payment.cardholder.name')"
        :placeholder="tr('pages.sales.checkout.form.payment.cardholder.name')"
        extra-class="w-full mb-4 md:w-1/2 md:mr-10 xl:mr-20 xl:mb-6"
        :error="$v.name.$error ? tr('errors.type.required') : ''"
        autocomplete="cc-name"
        @change="nameDirty = true"
      />

      <TextInput
        v-model.trim="email"
        :disabled="locked"
        :label="tr('pages.sales.checkout.form.payment.cardholder.email')"
        :placeholder="tr('pages.sales.checkout.form.payment.cardholder.email')"
        extra-class="w-full mb-4 md:w-1/2 md:mr-10 xl:mr-20 xl:mb-6"
        :error="emailError"
        autocomplete="email"
        @change="emailDirty = true"
      />

      <div class="py-5 md:py-0">
        <Button
          v-if="!locked"
          key="confirm"
          variant="secondary"
          type="submit"
        >
          {{ tr('pages.sales.checkout.form.payment.cardholder.confirm') }}
        </Button>
        <Button
          v-if="locked"
          key="unlock"
          variant="primary-border"
          type="button"
          class="whitespace-no-wrap"
          @click="$emit('unlock')"
        >
          {{ tr('pages.sales.checkout.form.payment.cardholder.unlock') }}
        </Button>
      </div>
    </div>
  </form>
</template>

<script>
import TextInput from '~brand-components/lufthansa/shared/text-input.vue'
import Button from '~brand-components/lufthansa/button/button.vue'
import Card3dsInformationForm from '~brand-components/base/sale/card-3ds-information-form.js'

export default Card3dsInformationForm.extend({
  components: {
    TextInput,
    Button,
  },

})
</script>
